module.exports = __webpack_public_path__ + "media/bootstrap-icons/twitch-94c2fb0b.svg";